import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BetaBanner from "@/components/BetaBanner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <BetaBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
